module.exports = __webpack_public_path__ + "media/common/icon_user-bd4b158b.svg";